import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M4 12l8 8 8-8 8 8" fill="none" />
  </Icon>
);
